module.exports = ->
  window.getSelection?()?.toString() ||
  document.selection?.createRange().text



// WEBPACK FOOTER //
// ./app/scripts/lib/util/selection/has-selection.coffee